import React, { useState } from 'react';
import ActivityItem from './activity-item';
import { styled } from 'themes';
import { Box } from 'components';
import Modal from './modal';
import Fade from 'react-reveal/Fade';
import { device } from 'themes/media-queries';

const PublicActivty = props => {
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  function onActivityItemPress(item) {
    setSelectedItem(item);
    setShowModal(true);
  }

  function onClose(e) {
    setShowModal(false);
  }

  return (
    <Section>
      <Header>Just nu på Yepstr</Header>

      <PublicItemList>
        {props.items.map((item, i) => {
          return (
            <ActivityItem
              key={i}
              onClick={() => onActivityItemPress(item)}
              item={item}
            />
          );
        })}
      </PublicItemList>

      <ModalWrapper showModal={showModal}>
        <Fade bottom duration={500} when={showModal}>
          <Modal onClose={onClose} item={selectedItem || {}} />
        </Fade>
      </ModalWrapper>
    </Section>
  );
};

const Section = styled.article`
  position: block;
  display: flex;
  flex-direction: column;
  left: 0;
  bottom: 0;
  width: 100%;
`;

const Header = styled.p`
  padding: 0 1.5rem 1rem;
`;

const PublicItemList = styled(Box)`
  display: block;
  padding: 1.5rem;
  overflow-y: scroll;
  height: 75rem;

  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    -webkit-appearance: none;
    background: transparent; // HERE IS THE TRICK
  }

  @media ${device.laptopL} {
    display: flex;
    overflow-x: scroll;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
  }
`;
const ModalWrapper = styled(Box)`
  display: ${({ showModal }) => (showModal ? 'block' : 'none')};
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: 20%;
  max-width: 320px;

  @media ${device.mobileL} {
    top: 17%;
  }
`;

export default PublicActivty;
